import formatDate from "./formatDate";

type PutUrlSearchParams = (search: object | undefined) => void;

const putUrlSearchParams: PutUrlSearchParams = (search: any | undefined) => {
	const searchTerm = search;

	if(!searchTerm)
		return;

	// Removes (undefined, null, empty strings, strings equals "null", invalid date) from the object
	const newObjToUrl = {...searchTerm};
	Object.keys(searchTerm).forEach((key) => {
		if(searchTerm[key] === undefined || searchTerm[key] === null || (typeof searchTerm[key] === "string" && (searchTerm[key].trim().length === 0 || searchTerm[key] === "null")))
			delete newObjToUrl[key];

		if(searchTerm[key] instanceof Date)
			newObjToUrl[key] = formatDate(searchTerm[key]);
			
	});

	window.history.replaceState(null, "", `?${new URLSearchParams(newObjToUrl).toString().replaceAll("%2C", ",")}`);
};

export default putUrlSearchParams;
